var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 31,
    viewBox: "0 0 6 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24557 0.0605469C1.85367 0.0605469 0.714844 1.19937 0.714844 2.59127C0.714844 3.98317 1.85367 5.122 3.24557 5.122C4.63747 5.122 5.7763 3.98317 5.7763 2.59127C5.7763 1.19937 4.63747 0.0605469 3.24557 0.0605469ZM3.24557 25.3678C1.85367 25.3678 0.714844 26.5066 0.714844 27.8985C0.714844 29.2904 1.85367 30.4293 3.24557 30.4293C4.63747 30.4293 5.7763 29.2904 5.7763 27.8985C5.7763 26.5066 4.63747 25.3678 3.24557 25.3678ZM3.24557 12.7142C1.85367 12.7142 0.714844 13.853 0.714844 15.2449C0.714844 16.6368 1.85367 17.7756 3.24557 17.7756C4.63747 17.7756 5.7763 16.6368 5.7763 15.2449C5.7763 13.853 4.63747 12.7142 3.24557 12.7142Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotIcon);
export default __webpack_public_path__ + "static/media/ThreeDotIcon.6d79621bc9a2d9e94b4907fa4a2fa8fb.svg";
export { ForwardRef as ReactComponent };